import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {environment} from "../../../../../environments/environment";
import {map, switchAll, take} from "rxjs/operators";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {interval} from "rxjs/observable/interval";

@Component({
  selector: 'vb-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css']
})
export class TimerComponent implements OnInit, OnDestroy {

  @Output()
  timeout: EventEmitter<any> = new EventEmitter();

  @Input()
  timeoutInterval: number = environment.touch && environment.touch.timeout ? environment.touch.timeout : 120;

  @Input()
  userEvent: Observable<any>;

  private userEventSub: Subscription;

  timer: BehaviorSubject<Date>;

  constructor() {
  }

  ngOnInit() {
    this.timer = new BehaviorSubject(new Date(this.timeoutInterval * 1000));

    this.userEventSub = this.userEvent.pipe(
      map(() => {
          let str = new Date(this.timeoutInterval * 1000);
          this.timer.next(str);
          return interval(1000).pipe(
            take(this.timeoutInterval + 1)
          );
        }
      ),
      switchAll() // Forget all running timers and take the last, new timer
    )
      .subscribe(
        x => {
          if (x < this.timeoutInterval) {
            let str = new Date((this.timeoutInterval - x) * 1000);
            this.timer.next(str);
          } else {
            console.log("Inactivity interval expired! Dispatching timeout event");
            this.timeout.next();
          }
        },
        e => {
          console.error("Timer-Error!");
        },
        () => {
          console.log("User event stream completed!");
        });
  }

  setColor() {
    let startTime = new Date(this.timeoutInterval * 1000).getSeconds();
    let time = this.timer.getValue().getSeconds();
    let rel = time / startTime;
    return {
      'text-danger': rel <= 0.25,
      'text-warning': rel <= 0.5 && rel > 2.5
    }
  }

  startTimer() {

  }

  resetTimer() {

  }

  stopTimer() {

  }

  ngOnDestroy(): void {
    if (this.userEventSub) {
      this.userEventSub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/timer/timer.component.ts